
import React from 'react';
import { FacilityOrderTemplateItemNewFlowCalculationModalTemplate } from 'themes/application/facility-order-new-flow/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderTemplateItemNewFlowCalculationModalStore } from 'application/facility-order-new-flow/stores';

@setCurrentView((rootStore, componentProps) => new FacilityOrderTemplateItemNewFlowCalculationModalStore(rootStore, componentProps), 'facilityOrderTemplateItemNewFlowCalculationModalStore')
@observer
class FacilityOrderTemplateItemNewFlowCalculationModal extends React.Component {
    render() {
        return <FacilityOrderTemplateItemNewFlowCalculationModalTemplate {...this.props} />
    }
}

export default FacilityOrderTemplateItemNewFlowCalculationModal;
